/* =========================================================
   Kipor Cart Drawer — Verhalten (Muster: VSR-Theme)
   - Document-Level-Submit-Interception: fängt jeden nativen
     POST auf /cart/add ab (PDP-Form, Sticky-Bar, Specs-Modal)
     und öffnet den Drawer statt auf /cart umzuleiten.
   - Header-Warenkorb-Icon öffnet den Drawer.
   - Mengen ändern / entfernen / Quick-Add per AJAX-API mit
     Section Rendering (sections=kipor-cart-drawer).
   - Auf der Warenkorbseite ist dieses Script komplett inaktiv —
     dort übernimmt section-kipor-cart.js.
   Ohne JavaScript: nativer POST + Redirect auf /cart (Fallback).
   ========================================================= */

(function () {
  'use strict';

  // Auf der Warenkorbseite nichts tun — Icon-Link und Formulare bleiben nativ.
  if (document.querySelector('[data-kipor-cart]')) return;

  var T = (window.KiporStrings && window.KiporStrings.drawer) || {};
  var DRAWER_SECTION = 'kipor-cart-drawer';
  var routes = window.routes || {
    cart_url: '/cart',
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
  };
  var inFlight = false;
  var lastFocus = null;

  function drawerEl() {
    return document.querySelector('[data-kipor-drawer]');
  }

  function innerEl() {
    var d = drawerEl();
    return d ? d.querySelector('[data-kipor-drawer-inner]') : null;
  }

  function announce(text) {
    var d = drawerEl();
    var live = d ? d.querySelector('[data-kipor-drawer-live]') : null;
    if (live) {
      live.textContent = '';
      live.textContent = text;
    }
  }

  function showError(text) {
    var d = drawerEl();
    var region = d ? d.querySelector('[data-kipor-drawer-error]') : null;
    if (!region) return;
    region.textContent = text || T.error_generic || 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.';
    region.hidden = false;
    window.clearTimeout(region._kdTimer);
    region._kdTimer = window.setTimeout(function () {
      region.hidden = true;
    }, 6000);
  }

  /* ---------- Öffnen / Schließen / Fokus ---------- */

  function openDrawer(withAdded, origin) {
    var d = drawerEl();
    if (!d) return;
    lastFocus = origin || document.activeElement;
    d.classList.add('is-open');
    d.classList.toggle('is-added', !!withAdded);
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kipor-drawer-lock');
    window.setTimeout(function () {
      var close = d.querySelector('[data-kipor-drawer-close][aria-label]');
      if (close) close.focus();
    }, 80);
    if (withAdded) announce(T.added || 'Artikel wurde in den Warenkorb gelegt');
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.classList.remove('is-added');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kipor-drawer-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  // Außenklick schließt — direkt am Drawer-Root gebunden, damit es auch
  // funktioniert, wenn andere Scripts Klicks per stopPropagation schlucken,
  // bevor sie die Document-Delegation erreichen. Der Root wird nie
  // ausgetauscht (Section-Swaps ersetzen nur [data-kipor-drawer-inner]),
  // die Bindung hält also dauerhaft.
  function ensureOutsideClose() {
    var d = drawerEl();
    if (!d || d.dataset.kdOutsideBound) return;
    d.dataset.kdOutsideBound = 'true';
    d.addEventListener('click', function (event) {
      if (!d.classList.contains('is-open')) return;
      var panel = d.querySelector('.kipor-drawer__panel');
      if (panel && !panel.contains(event.target)) closeDrawer();
    });
  }
  ensureOutsideClose();

  document.addEventListener('keydown', function (event) {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    // Fokus-Falle im Panel
    if (event.key === 'Tab') {
      var panel = d.querySelector('.kipor-drawer__panel');
      var focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- Section-Swap nach Mutationen ---------- */

  function applySections(sections) {
    var html = sections && sections[DRAWER_SECTION];
    var inner = innerEl();
    if (!html || !inner) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-kipor-drawer-inner]');
    if (!fresh) return;

    var items = inner.querySelector('[data-kipor-drawer-items]');
    var scrollTop = items ? items.scrollTop : 0;

    inner.innerHTML = fresh.innerHTML;

    var freshItems = inner.querySelector('[data-kipor-drawer-items]');
    if (freshItems) freshItems.scrollTop = scrollTop;

    // Fokus-Reparatur: Nach dem Swap darf der Fokus nicht auf <body> fallen
    var d = drawerEl();
    if (d && d.classList.contains('is-open') && document.activeElement === document.body) {
      var close = d.querySelector('[data-kipor-drawer-close][aria-label]');
      if (close) close.focus();
    }

    syncHeaderCount();
    announce(T.cart_updated || 'Warenkorb aktualisiert');
  }

  function syncHeaderCount() {
    var counter = document.querySelector('[data-kipor-drawer-count]');
    var count = counter ? parseInt(counter.dataset.kiporDrawerCount, 10) || 0 : 0;
    var cartLink = document.querySelector('.kipor-header__cart');
    if (!cartLink) return;
    var badge = cartLink.querySelector('.kipor-header__cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'kipor-header__cart-count';
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* ---------- Requests ---------- */

  function setBusy(busy) {
    inFlight = busy;
    var d = drawerEl();
    if (d) d.classList.toggle('is-busy', busy);
  }

  function handleResponse(res) {
    if (!res.ok) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (json) {
          throw new Error(json.description || json.message || '');
        });
    }
    return res.json();
  }

  function addFromForm(form, submitter) {
    var origin = submitter || document.activeElement;
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    setBusy(true);

    var body = new FormData(form);
    body.append('sections', DRAWER_SECTION);
    body.append('sections_url', routes.cart_url);

    fetch(routes.cart_add_url + '.js', { method: 'POST', body: body })
      .then(handleResponse)
      .then(function (json) {
        applySections(json.sections);
        openDrawer(true, origin);
        reconcileGift();
      })
      .catch(function (err) {
        openDrawer(false, origin);
        showError(err && err.message);
      })
      .finally(function () {
        setBusy(false);
        if (submitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      });
  }

  function drawerCouponMsg(text, isError) {
    var el = document.querySelector('[data-kipor-drawer-coupon-msg]');
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('kipor-drawer__coupon-msg--error', !!isError);
    el.removeAttribute('hidden');
  }

  /* Drawer neu rendern, ohne am Warenkorb etwas zu aendern — liefert die
     Section mit aktuellen Summen und Rabattzeilen zurueck. */
  function refreshDrawer() {
    return fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: {},
        sections: DRAWER_SECTION,
        sections_url: routes.cart_url,
      }),
    })
      .then(handleResponse)
      .then(function (json) {
        applySections(json.sections);
      });
  }

  /* Gutschein: /discount/<code> hinterlegt den Code auf der Session —
     dasselbe Verfahren wie auf der Warenkorbseite. Danach neu rendern,
     damit der Abzug sichtbar wird. Die Meldung kommt NACH dem Rendern,
     sonst wuerde sie vom neuen Markup ueberschrieben. */
  function applyDrawerCoupon() {
    var input = document.querySelector('[data-kipor-drawer-coupon-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      drawerCouponMsg(T.coupon_empty || 'Bitte einen Code eingeben.', true);
      return;
    }
    setBusy(true);
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
      .then(function () {
        return refreshDrawer();
      })
      .then(function () {
        /* Nach dem Neurendern ist das <details> wieder zu — aufklappen, sonst
           landet die Rueckmeldung unsichtbar im eingeklappten Bereich. */
        var details = document.querySelector('[data-kipor-drawer-coupon-details]');
        if (details) details.open = true;
        var fresh = document.querySelector('[data-kipor-drawer-coupon-input]');
        if (fresh) fresh.value = code;
        if (document.querySelector('[data-kipor-drawer-discount]')) {
          drawerCouponMsg(T.coupon_applied || 'Rabatt \u00fcbernommen.', false);
        } else {
          drawerCouponMsg(T.coupon_pending || 'Code gespeichert. Er greift, sobald die Bedingungen erf\u00fcllt sind.', false);
        }
      })
      .catch(function () {
        drawerCouponMsg(T.coupon_failed || 'Code konnte nicht \u00fcbernommen werden. Bitte im Checkout eingeben.', true);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target.closest('[data-kipor-drawer-coupon-input]')) return;
    event.preventDefault();
    applyDrawerCoupon();
  });

  function changeLine(key, quantity) {
    if (inFlight) return;
    setBusy(true);
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: DRAWER_SECTION,
        sections_url: routes.cart_url,
      }),
    })
      .then(handleResponse)
      .then(function (json) {
        applySections(json.sections);
        reconcileGift();
      })
      .catch(function (err) {
        showError(err && err.message);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function addVariant(variantId) {
    if (inFlight) return;
    setBusy(true);
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: DRAWER_SECTION,
        sections_url: routes.cart_url,
      }),
    })
      .then(handleResponse)
      .then(function (json) {
        applySections(json.sections);
        reconcileGift();
      })
      .catch(function (err) {
        showError(err && err.message);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  /* ---------- Aktion: Gratis-Beigabe automatisch pflegen ----------
     Konfiguration kommt aus theme.liquid (window.KiporAktion, gespeist aus
     den Theme-Einstellungen "🎁 Aktion"). Reconcile-Prinzip: nach jeder
     Cart-Mutation wird der Ist-Zustand geprüft und höchstens EINE
     Korrektur ausgeführt — dadurch konvergiert der Zustand und es kann
     keine Endlosschleife entstehen:
       - Aktionsgerät im Cart, Beigabe fehlt        → Beigabe hinzufügen
       - Aktionsgerät entfernt, Beigabe noch da     → Beigabe entfernen
         (sonst stünde sie plötzlich zum vollen Preis im Warenkorb)
       - Beigabe-Menge != 1                          → auf 1 klemmen
     Die Beigabe-Zeile trägt die Line-Item-Property _kipor_gift; der
     100 %-Rabatt selbst kommt vom automatischen BXGY-Rabatt im Admin. */

  var giftFailed = false; // z. B. Beigabe ausverkauft — keine weiteren Versuche
  var giftBusy = false;

  function giftMutate(url, body) {
    body.sections = DRAWER_SECTION;
    body.sections_url = routes.cart_url;
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(handleResponse)
      .then(function (json) {
        applySections(json.sections);
      });
  }

  function reconcileGift() {
    var cfg = window.KiporAktion;
    if (!cfg || !cfg.triggerProductId || !cfg.giftVariantId) return;
    if (giftFailed || giftBusy) return;
    giftBusy = true;

    fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(handleResponse)
      .then(function (cart) {
        var hasTrigger = false;
        var giftLine = null;
        (cart.items || []).forEach(function (item) {
          if (item.product_id === cfg.triggerProductId) hasTrigger = true;
          if (item.variant_id === cfg.giftVariantId && item.properties && item.properties[cfg.giftProperty]) {
            giftLine = item;
          }
        });

        if (hasTrigger && !giftLine) {
          var props = {};
          props[cfg.giftProperty] = 'aktion';
          return giftMutate(routes.cart_add_url, {
            items: [{ id: cfg.giftVariantId, quantity: 1, properties: props }],
          })
            .then(function () {
              announce(T.gift_added || 'Gratis-Beigabe wurde in den Warenkorb gelegt');
            })
            .catch(function () {
              giftFailed = true;
            });
        }

        if (giftLine && (!hasTrigger || giftLine.quantity !== 1)) {
          return giftMutate(routes.cart_change_url, {
            id: giftLine.key,
            quantity: hasTrigger ? 1 : 0,
          }).catch(function () {
            giftFailed = true;
          });
        }
      })
      .catch(function () {})
      .finally(function () {
        giftBusy = false;
      });
  }

  /* ---------- Add-to-Cart-Interception (Kern) ---------- */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.action !== 'string') return;
    if (event.defaultPrevented) return;
    if (form.hasAttribute('data-kipor-no-ajax')) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!drawerEl()) return;
    event.preventDefault();
    if (inFlight) return;
    addFromForm(form, event.submitter);
  });

  /* ---------- Klick-Delegation ---------- */

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-kipor-cart-open]');
    if (opener && drawerEl()) {
      event.preventDefault();
      openDrawer(false, opener);
      return;
    }

    var closer = event.target.closest('[data-kipor-drawer-close]');
    if (closer) {
      closeDrawer();
      return;
    }

    var couponBtn = event.target.closest('[data-kipor-drawer-coupon-apply]');
    if (couponBtn) {
      applyDrawerCoupon();
      return;
    }

    var qtyBtn = event.target.closest('[data-kipor-dqty]');
    if (qtyBtn) {
      var qty = parseInt(qtyBtn.dataset.quantity, 10) || 1;
      var next = qtyBtn.dataset.kiporDqty === 'plus' ? qty + 1 : qty - 1;
      if (next < 0) next = 0;
      changeLine(qtyBtn.dataset.key, next);
      return;
    }

    var removeBtn = event.target.closest('[data-kipor-drawer-remove]');
    if (removeBtn) {
      changeLine(removeBtn.dataset.kiporDrawerRemove, 0);
      return;
    }

    var addBtn = event.target.closest('[data-kipor-drawer-add]');
    if (addBtn) {
      // Bei Varianten-Produkten zählt die Auswahl im Karten-Select
      var card = addBtn.closest('.kipor-drawer__xsell-card');
      var select = card ? card.querySelector('[data-kipor-drawer-variant]') : null;
      var variantId = select ? parseInt(select.value, 10) : parseInt(addBtn.dataset.kiporDrawerAdd, 10);
      addVariant(variantId);
    }
  });

  // Varianten-Wechsel im Zubehör-Select: Preis der Karte mitführen
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-kipor-drawer-variant]');
    if (!select) return;
    var card = select.closest('.kipor-drawer__xsell-card');
    var priceEl = card ? card.querySelector('[data-kipor-xsell-price]') : null;
    var option = select.options[select.selectedIndex];
    if (priceEl && option && option.dataset.price) priceEl.textContent = option.dataset.price;
  });

  // Lieferzeit: Metafeld-Text wird unverändert per Liquid ausgegeben (wie auf
  // der PDP) — bewusst keine Umrechnung in Datumsangaben mehr.

  // Beim Seitenaufruf einmal abgleichen — deckt Fälle ab, in denen der Cart
  // ohne JS (oder vor Aktivierung der Aktion) befüllt wurde.
  reconcileGift();
})();
